export default __webpack_public_path__ + "static/media/expl-nn_09_EN.96d79c9b.png";